import { condClass } from 'app/utils/general';
import React, { useMemo } from 'react';
import { components, OptionsType, ValueType, StylesConfig } from 'react-select';
import AsyncSelect from 'react-select/async';

import classes from './MAddressInput.module.scss';

interface Props {
  className?: string;
  placeholder?: string;
  customStylesSelect?: StylesConfig<{ label: string; value: string }, false>;
  name?: string;
  value?: ValueType<{ label: string; value: string }, false>;
  disabled?: boolean;
  size?: string;
  onChange?: (value: ValueType<{ label: string; value: string }, false>) => void;
  loadOptions: (inputValue: string, callback: (options: OptionsType<{ label: string; value: string }>) => void) => void;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
  onMenuClose?: () => void;
}

const Menu = (props) => {
  if (props.selectProps.inputValue.length === 0) {
    return null;
  }

  return <components.Menu {...props}></components.Menu>;
};

const AddressInput: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const customStylesSelect: StylesConfig<{ label: string; value: string }, false> = useMemo(() => {
    return {
      valueContainer(base) {
        return {
          ...base,
          margin: 0,
          padding: 0,
          fontSize: '14px !important',
        };
      },
      control(base) {
        return {
          ...base,
          border: 'none',
          boxShadow: 'none',
          fontSize: 30,
          cursor: 'text',
        };
      },
      placeholder(base) {
        return {
          ...base,
          color: '#787878',
          fontSize: '1.6rem',
          outline: 'none',
        };
      },
      dropdownIndicator() {
        return {
          display: 'none',
        };
      },
      indicatorSeparator() {
        return {
          display: 'none',
        };
      },
      menu(base) {
        return {
          ...base,
          border: 'none',
          boxShadow: '0 5px 10px rgba(0, 0, 0, .2)',
        };
      },
      option(base) {
        return {
          ...base,
          fontSize: '1.6rem',
          padding: '20px',
        };
      },
      ...props.customStylesSelect,
    };
  }, []);

  return (
    <AsyncSelect
      className={condClass({ [classes['container']]: true, [String(props.className)]: !!props.className })}
      placeholder={props.placeholder}
      cacheOptions
      styles={customStylesSelect}
      loadOptions={props.loadOptions}
      components={{ Menu }}
      onChange={props.onChange}
      value={props.value}
      onBlur={props.onBlur}
      onMenuClose={props.onMenuClose}
      isDisabled={props.disabled}
    ></AsyncSelect>
  );
};

export default AddressInput;
